import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { createRouter, RouterProvider } from "@tanstack/react-router";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { REFRESH_ON_WINDOW_FOCUS, RETRY, STALE_TIME } from "./lib/query-client.js";
import { routeTree } from "./routeTree.gen.js";
import "./globals.css";
// 初始化 i18n 并让语言偏好（持久化/浏览器检测）在首次渲染前生效
import "./stores/locale.js";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: STALE_TIME,
      retry: RETRY,
      refetchOnWindowFocus: REFRESH_ON_WINDOW_FOCUS,
    },
    mutations: {
      onError: (error) => {
        // Global mutation error toast — will use Sonner when UI is built
        console.error("Mutation error:", error);
      },
    },
  },
});

const router = createRouter({
  routeTree,
  context: {
    queryClient,
  },
});

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}

const rootElement = document.getElementById("root");
if (!rootElement) throw new Error("Root element #root not found");
createRoot(rootElement).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  </StrictMode>,
);
